export const searchTooltipText = 'Search by user name, email or organization name';
export const searchPlaceholder = 'Search by user name, email...';
